/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize AppointmentsManagement View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AppointmentsManagementView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsAppointmentsManagement = mapStateToProps;
export const mapDispatchToPropsAppointmentsManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsAppointmentsManagement,
  mapDispatchToPropsAppointmentsManagement
)(View);
